import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["country", "province"]
  static values = {
    provincesUrl: String,
    loading: { type: String, default: "Loading provinces..." },
    error: { type: String, default: "Error loading provinces" },
    select: { type: String, default: "Select Province or State" }
  }

  connect() {
    console.log("Address form controller connected")
    console.log("Provinces URL:", this.provincesUrlValue)
    console.log("Country target:", this.countryTarget)
    console.log("Province target:", this.provinceTarget)

    // Initialize with default country if already selected
    if (this.countryTarget.value) {
      console.log("Initial country value:", this.countryTarget.value)
      // Store the current province value before loading
      this.initialProvinceValue = this.provinceTarget.value
      this.loadProvinces()
    }
  }

  countryChanged() {
    console.log("Country changed to:", this.countryTarget.value)
    this.loadProvinces()
  }

  loadProvinces() {
    const countryCode = this.countryTarget.value

    if (!countryCode) {
      this.clearProvinces()
      return
    }

    // Show loading state with spinner
    this.provinceTarget.innerHTML = `<option value="">🔄 ${this.loadingValue}</option>`
    this.provinceTarget.disabled = true
    this.provinceTarget.classList.add('loading')

    // Add a small delay to show the loading state
    setTimeout(() => {
      // Fetch provinces for selected country
      fetch(`${this.provincesUrlValue}?country_code=${countryCode}`)
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok')
          }
          return response.json()
        })
        .then(data => {
          this.updateProvinces(data.provinces)
        })
        .catch(error => {
          console.error('Error fetching provinces:', error)
          this.provinceTarget.innerHTML = `<option value="">❌ ${this.errorValue}</option>`
          this.provinceTarget.disabled = false
          this.provinceTarget.classList.remove('loading')
        })
    }, 300) // 300ms delay to show loading state
  }

  updateProvinces(provinces) {
    // Store the current value (or initial value if this is the first load)
    const currentValue = this.initialProvinceValue || this.provinceTarget.value

    // Clear existing options
    this.provinceTarget.innerHTML = `<option value="">${this.selectValue}</option>`

    // Add new options
    provinces.forEach(province => {
      const option = document.createElement('option')
      option.value = province[1] // province code
      option.textContent = province[0] // province name

      // Select the current/initial value if it matches
      if (province[1] === currentValue) {
        option.selected = true
      }

      this.provinceTarget.appendChild(option)
    })

    this.provinceTarget.disabled = false
    this.provinceTarget.classList.remove('loading')

    // Clear the initial value after first use
    this.initialProvinceValue = null
  }

  clearProvinces() {
    this.provinceTarget.innerHTML = `<option value="">${this.selectValue}</option>`
    this.provinceTarget.disabled = false
    this.provinceTarget.classList.remove('loading')
  }
}
